/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'previous': {
    width: 9.968,
    height: 16.969,
    viewBox: '0 0 9.968 16.969',
    data: '<defs/><path pid="0" id="previous" class="cls-1" d="M657.348 37.951l-8.536-8.491 8.536-8.491 1.435 1.427-7.1 7.064 7.1 7.064z" transform="translate(-648.813 -20.969)"/>'
  }
})
